/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Box } from '@chakra-ui/react';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getCellStatus } from '../../utils/FormatFunctions';
import { RowIdentity } from '../../components/ui';
import { useAuth } from '../../providers/auth';

export function SecretariesPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/secretaries`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { user } = useAuth();
  const groupIds = user?.group?.id;

  const columns = [
    { name: 'name', label: 'Nome' },
    { name: 'responsible', label: 'Responsável' },
    { name: 'status', label: 'Status' },
  ];

  return (
    <Box>
      <PageTitle description="Gerencie as secretarias municipais e seus responsáveis.">
        Secretarias
      </PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 3 && groupIds !== 6}
        loading={loading}
        rowActions={{ show: false, edit: groupIds !== 3, delete: groupIds !== 6 && groupIds !== 3 }}
        columnWithAction={[
          {
            name: 'name',
            columnAction: (rowItem) => (
              <RowIdentity
                title={rowItem?.name}
                meta={rowItem?.site}
                image={rowItem?.image?.medium}
              />
            ),
          },
        ]}
        formatColum={[
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />
    </Box>
  );
}
